import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "lineItems",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Line Items...",
      sortBy: "description",
      fields: [
        { key: "description", label: "Description", sortable: true },
        { key: "default_rate", label: "Default Rate", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    lineItems: function() {
      return this.$store.getters.lineItemsForTable;
    },
  },
  created() {
    const jsConn = new JSConn();
    this.$store.dispatch("needLineItems", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
};
